export function setData() {
	return Object.assign(this, ...arguments)
}

export function $now() {
	return ~~~(Date.now() / 1000)
}


export const $log = console.log

// 语言包 rules 做混和  
export function rules_mix(rules, lang_obj) {
	Object.entries(rules).forEach(([key, obj]) => {
		obj.message = lang_obj[key]
	})
	return rules
}


export const json = JSON.stringify

export function parse(str, df = {}) {
	if (!str) {
		return df;
	}
	try {
		return JSON.parse(str)
	} catch (e) {
		return df;
	}
}



export const $defaultImg = 'this.src="' + require('@/assets/404_images/error.jpg') + '"'